import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  newProposalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: `1px solid ${foundations.colors.gray100}`,
    padding: '8px 16px',
  },
  textBox: {
    alignSelf: 'center',
    width: '184px',
  },
  replaceWith: {
    alignSelf: 'center',
    width: '88px',
  },
  proposalListSelect: {
    width: '184px',
  },
});
